<template>
  <section>
    <Sidebar
      v-if="!mapHidden && !mapMobile"
      :expanded="!mapExpanded"
      :onMobileToggle="handleMapMobileToggle"
      title="Forecast Regions"
    >
      <Notification slot="notification" />
      <Header slot="header" :expanded="!mapExpanded">
        <Filters
          title="Sort by:"
          :filters="filters"
          :currentFilter="currentFilter"
          :currentFilterOrder="currentFilterOrder"
          :onFilterButtonClick="handleFilterButtonClick"
        />
      </Header>
      <Tiles
        slot="body"
        :regions="regionsFilteredByMapBounds"
        :selectedRegion="selectedRegion.id"
        :expanded="!mapExpanded"
        :currentFilter="currentFilter"
        :currentFilterOrder="currentFilterOrder[currentFilter]"
        :onTileClick="handleTileClick"
      />
      <Footer slot="footer" :showDangerScale="true" />
    </Sidebar>
    <Footer v-else :showDangerScale="true" />
  </section>
</template>

<script>
import Filters from "../filters/Filters";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import Sidebar from "../sidebar/Sidebar";
import Tiles from "../tiles/Tiles";
import Notification from "../notification/Notification";

import { mapState } from "vuex";

export default {
  components: {
    Filters,
    Header,
    Footer,
    Sidebar,
    Tiles,
    Notification,
  },

  props: {
    filters: {
      type: Array,
      default() {
        return [
          {
            label: "Danger Level",
            filterOn: "dangerRating"
          },
          {
            label: "North to South",
            filterOn: "sortOrder"
          },
          {
            label: "Last Updated",
            filterOn: "lastUpdated"
          }
        ];
      }
    },
    handleTileClick: Function,
    handleMapMobileToggle: Function,
    mapHidden: Boolean,
    mapExpanded: Boolean,
    mapMobile: Boolean,
    visibleMapRegions: Array
  },

  data() {
    return {
      currentFilter: "dangerRating",
      currentFilterOrder: {
        sortOrder: "ASC",
        dangerRating: "ASC",
        lastUpdated: "ASC"
      }
    };
  },

  computed: {
    ...mapState({
      regions: state => state.regions.filter(region => region.geometry !== null),
      selectedRegion: state => state.selectedRegion,
      forecasts: state => state.forecasts
    }),

    regionsFilteredByMapBounds() {
      return this.regions.filter(region => this.visibleMapRegions.includes(region.id));
    }
  },

  methods: {
    handleFilterButtonClick(event, filterOn) {
      const filterChanged = this.currentFilter !== filterOn;

      this.currentFilter = filterOn;

      // Only update the order when toggling the current filter,
      // never when switching between filters.
      if (!filterChanged) {
        this.currentFilterOrder[filterOn] = this.currentFilterOrder[filterOn] === "ASC" ? "DESC" : "ASC";
      }
    }
  }
};
</script>
